module.exports = __webpack_public_path__ + "media/coffee-preferences/coarse_grind-dbf62b74.png";